import { backBtnStyle, sharedStyles } from "@lib/sharedStyles";
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

const API_BASE = (window.location.port === '5173') ? 'http://localhost:8002' : '';
//
function navigate(path: string) {
	const state = {};
	window.history.pushState(state, '', path);
	window.dispatchEvent(new PopStateEvent('popstate'));
}

@customElement('quiz-start-page')
export default class StartPage extends LitElement {
	static styles = [
		sharedStyles,
		backBtnStyle,
		css`
	:host { display: block; padding: 2rem; font-family: system-ui, Arial, sans-serif; }
	h1 { margin-top: 0; }
	ul { list-style: none; padding: 0; margin: 1rem 0; display: grid; gap: 0.75rem; max-width: 420px; }
	li { }
	li a, li button { display: inline-block; width: 100%; text-align: left; padding: 0.75rem 1rem; border-radius: 8px; border: 1px solid #ddd; background: #fafafa; cursor: pointer; font-size: 1rem; }
	li a:hover, li button:hover { background: #f0f0f0; }
	.muted { color: #666; font-size: 0.9rem; }
	`
	];

	private createNewQuiz = () => {
		// Generate a client-side ID compatible with backend CharField primary key
		const id = `Quiz-${crypto.randomUUID()}`;
		navigate(`/quiz/create/${id}`);
	};

	render() {
		return html`
      <a href="/host/events" class="back-btn" @click="${this.handleBackClick}">←</a>
      <h1>The Big Bash - Jeopardy Menu</h1>
      <ul>
        <li>
          <success-button @click=${this.createNewQuiz}>Create Jeopardy-Quiz</button>

        </li>
        <li>
          <warning-button href="/questions" @click=${(e: Event) => { e.preventDefault(); navigate('/questions'); }}>Manage Jeopardy Questions</warning-button>
        </li>
        <li>
          <warning-button href="/millionaire-questions" @click=${(e: Event) => { e.preventDefault(); navigate('/millionaire-questions'); }}>Manage Millionaire Questions</warning-button>
        </li>
        <li>
          <alert-button href="/quizzes" @click=${(e: Event) => { e.preventDefault(); navigate('/quizzes'); }}>My Quizzes</alert-button>
        </li>
      </ul>
    `;
	}
}
